<glxy-form-field size="small">
  <mat-select [value]="selectedFrequency" (selectionChange)="handleBillingFrequencyChange($event.value)">
    <mat-option *ngFor="let frequency of frequencyOptions" [value]="frequency.value">
      {{ frequency.label | translate }}
    </mat-option>
  </mat-select>
</glxy-form-field>
